import { render, staticRenderFns } from "./CancelBookingDialog.vue?vue&type=template&id=fee454ca&scoped=true&"
import script from "./CancelBookingDialog.vue?vue&type=script&lang=js&"
export * from "./CancelBookingDialog.vue?vue&type=script&lang=js&"
import style0 from "./CancelBookingDialog.vue?vue&type=style&index=0&id=fee454ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee454ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VLayout,VProgressCircular})
